/**
 * @package   ats
 * @copyright Copyright (c)2011-2026 Nicholas K. Dionysopoulos / Akeeba Ltd
 * @license   GNU General Public License version 3, or later
 */

"use strict";

window.addEventListener("DOMContentLoaded", function ()
{
    var batchCancel = document.getElementById("ats_batch_cancel");
    var batchRun    = document.getElementById("ats_batch_run");

    if (batchCancel)
    {
        batchCancel.addEventListener("click", function ()
        {
            document.getElementById("batch-assigned-to").value = "";
            document.getElementById("batch-category-id").value = "";
            document.getElementById("batch-tag-id").value      = "";
            document.getElementById("batch-status").value      = "";
            document.getElementById("batch-public").value      = "";
            document.getElementById("batch-priority").value    = "";
        });
    }

    if (batchRun)
    {
        batchRun.addEventListener("click", function (e)
        {
            e.preventDefault();
            Joomla.submitbutton("ticket.batch");
        });
    }
});
